/**
 * Message Component
 * Alert/notification message with different variants
 */

import React from 'react';

const Message = ({
  children,
  type = 'info',
  className = '',
  ...props
}) => {
  if (!children) return null;

  return (
    <div className={`rf-message rf-message-${type} ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Message;
